module.exports = __webpack_public_path__ + "static/media/_title_16.7bc48587.svg";